import { useContext, useEffect, useState } from 'react';
import ScorecardContext from '../../../contexts/ScorecardContext';
import { isKpiRow } from 'hooks/kpiTypeCheckers';

const useKpiTrend = (
  kpi: Scorecards.ScorecardKpi | Scorecards.ManualKpiRow,
) => {
  const { data } = useContext(ScorecardContext);
  const [trend, setTrend] = useState<Goals.TrendResult[] | undefined>();

  useEffect(() => {
    if (isKpiRow(kpi)) {
      if (!data) {
        setTrend(undefined);
        return;
      }

      const newResult = data.find((d) => d.id === kpi.id);
      if (!newResult) {
        setTrend(undefined);
        return;
      }

      setTrend(newResult.trend);
    } else {
      setTrend(kpi.data);
    }
  }, [data, kpi, kpi.id]);

  return trend;
};

export default useKpiTrend;
